<div class="form-check form-switch">
  <input type="checkbox" class="form-check-input" [checked]="model" (change)="modelChange.emit(!model)" [attr.disabled]="disabled ? '' : null">
  <label class="form-check-label">{{label}}</label>
</div>